<template>
    <div class="bg-white my-4 rounded-lg divide-y max-w-5xl py-4">
        <draggable
            v-model="data"
            ghost-class="bg-gray-200"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div
                class="border bg-gray-100 rounded faq-item relative cursor-move  p-4 my-3 mx-2"
                v-for="(datum, index) in data"
                :key="`faq-${index}`"
            >
                <button
                    class="absolute top-4 right-4"
                    @click="() => handleDelete(index)"
                >
                    <svg
                        v-if="data.length > 1"
                        class="w-4 h-4"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                    </svg>
                </button>
                <div>
                    <input-text
                        :label="keyLabel"
                        :name="`${inputName}[${index}][${keyAttribute}]`"
                        v-model="datum[keyAttribute]"
                    />
                    <error
                        :error="
                            errorBag[`${inputName}.${index}.${keyAttribute}`]
                                ? errorBag[
                                      `${inputName}.${index}.${keyAttribute}`
                                  ][0]
                                : null
                        "
                    />
                </div>
                <div>
                    <input-text
                        class="mt-2"
                        :name="`${inputName}[${index}][${valueAttribute}]`"
                        :label="valueLabel"
                        v-model="datum[valueAttribute]"
                    />
                    <error
                        :error="
                            errorBag[`${inputName}.${index}.${valueAttribute}`]
                                ? errorBag[
                                      `${inputName}.${index}.${valueAttribute}`
                                  ][0]
                                : null
                        "
                    />
                </div>
            </div>
            <button
                class="mt-2 text-indigo-600 hover:text-indigo-900"
                @click="AddItem"
            >
                + {{ addButtonText }}
            </button>
        </draggable>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {useFroalaStore} from "../../stores/froala";
export default {
    name: "KeyValueInput",
    components: { draggable },
    props: {
        value: Array,
        errorBag: {
            type: [Object, Array],
            required: false,
        },
        keyLabel: {
            type: String,
            required: true,
        },
        keyAttribute: {
            type: String,
            required: true,
        },
        valueLabel: {
            type: String,
            required: true,
        },
        valueAttribute: {
            type: String,
            required: true,
        },
        addButtonText: {
            type: String,
            required: true,
        },
        inputName: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            data: this.value
                ? this.value
                : [
                      {
                          [this.keyAttribute]: "",
                          [this.valueAttribute]: "",
                      },
                  ],
            froalaStore: useFroalaStore(),
        };
    },
    updated() {
        this.$emit("input", this.data);
    },
    methods: {
        AddItem(e) {
            e.preventDefault();
            this.data.push({
                [this.keyAttribute]: "",
                [this.valueAttribute]: "",
            });
        },
        handleDelete: function (indexOfItemToDelete) {
            this.data = this.data.splice(indexOfItemToDelete, 1);
        },
    },
    watch: {
        value(newValue) {
            if (!newValue) return;
            this.data = newValue;
        },
    },
};
</script>
